const LOGO_PATTERN =
  /(?:logo|brand|agent[_-]?photo|static_agent_logo|zoopla_static_agent|avatar|favicon|\/icons?\/|sprite|badge|placeholder|powered[_-]?by|footer|header|social|facebook|twitter|linkedin)/i;

export function isLikelyLogoUrl(url) {
  if (!url || typeof url !== 'string') return true;
  const u = url.trim();
  if (u.length < 12) return true;
  if (u.endsWith('.svg') || u.includes('.svg?')) return true;
  if (LOGO_PATTERN.test(u)) return true;
  const w = u.match(/[?&](?:w|width)=(\d+)/i);
  if (w && Number(w[1]) < 100) return true;
  return false;
}

export function normalizeImageList(imageUrl, imageUrls) {
  const urls = [];
  if (imageUrls) {
    if (Array.isArray(imageUrls)) {
      urls.push(...imageUrls.filter(Boolean));
    } else if (typeof imageUrls === 'string') {
      try {
        const parsed = JSON.parse(imageUrls);
        if (Array.isArray(parsed)) urls.push(...parsed.filter(Boolean));
        else if (parsed) urls.push(parsed);
      } catch {
        urls.push(imageUrls);
      }
    }
  }
  if (imageUrl) urls.unshift(imageUrl);
  return [...new Set(urls.map((u) => String(u).trim()).filter(Boolean))];
}

/** Pick hero image for cards — middle photo when gallery includes logos. */
export function pickPrimaryImage(property) {
  if (!property) return null;
  const urls = normalizeImageList(property.image_url, property.image_urls);
  if (!urls.length) return null;
  const photos = urls.filter((u) => !isLikelyLogoUrl(u));
  if (!photos.length) return null;
  if (photos.length === 1) return photos[0];
  return photos[Math.floor(photos.length / 2)];
}
